<template>
  <v-dialog v-model="inboxInfoDialog" width="800">
    <v-card>
      <v-toolbar flat>
        <v-spacer></v-spacer>
        <span class="display-1 text-uppercase font-weight-bold">{{$t('infoDialogs.private.inbox.Title')}}</span>
        <v-spacer></v-spacer>
        <v-btn color="error" :title="$t('infoDialogs.private.inbox.Close window')" class="ma-2" outlined icon large @click="closeDialog">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <p class="pr-5 text--primary title pt-5">{{$t('infoDialogs.private.inbox.PageDescription')}}.</p>
        <v-divider></v-divider>
        <v-divider></v-divider>
        <v-row>
          <v-col md="12" class="pt-10">
            <span class="body-1 text--primary font-weight-bold">{{$t('infoDialogs.private.inbox.PageActionsOne')}}</span>
            <span><v-btn color="error" class="ml-5">{{$t('infoDialogs.private.inbox.Report')}}</v-btn></span>
          </v-col>
          <v-col md="12">
            <span class="body-1 text--primary font-weight-bold">{{$t('infoDialogs.private.inbox.PageActionsTwo')}}</span>
            <span><v-btn color="warning" class="ml-5">{{$t('infoDialogs.private.inbox.Hide')}}</v-btn></span>
          </v-col>
          <v-col md="12">
            <span class="body-1 text--primary font-weight-bold">{{$t('infoDialogs.private.inbox.PageActionsThree')}}</span>
            <span><v-btn color="success" class="ml-5">{{$t('infoDialogs.private.inbox.Reply')}}</v-btn></span>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
// Import the i18n - This may need to be modified
import messages from "../../modules/lang/export";
export default {
  // Communicate with i18n
  i18n: { messages },
  data(){
    return{
      // Define the dialog v-model that we are using
      inboxInfoDialog:false,
    }
  },
  methods: {
    // Opening the dialog through the ref
    openDialog() {
      this.inboxInfoDialog = true;
    },
    // Close the dialog
    closeDialog() {
      this.inboxInfoDialog = false;
    }
  }
}
</script>